import React from 'react'
import Header from '../CommonComponents/Header';
import { useParams } from 'react-router-dom';
import CcSecQuestions from '../Student/CodingChallenge/CcSecQuestions'

const PublicProfileSectionPage = () => {
    const { idHash, username } = useParams();
    const isLoggedIn = !!localStorage.getItem("tokenKey");
  return (
    <div className='publicProfileSectionContainer'>
        {!isLoggedIn && <Header />}
        {(idHash && username) && (
            <CcSecQuestions />
        )}
    </div>
  )
}

export default PublicProfileSectionPage;
